import { render, staticRenderFns } from "./OrderExtras.vue?vue&type=template&id=aacf391c"
import script from "./OrderExtras.vue?vue&type=script&lang=js"
export * from "./OrderExtras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports